/** @format */

import React from 'react';
import PropTypes from 'prop-types';

import update from 'immutability-helper';

/**
 * Allow editing of a single field. Simple wrapper to add state to a toggleable component between editing and viewing
 * @param ComponentContainer
 * @returns {{defaultProps, new(props: Readonly<P>): {state, handleChange, handleSave, render: {(): *, (): React.ReactNode}, componentDidMount?(): void, shouldComponentUpdate?(nextProps: Readonly<P>, nextState: Readonly<S>, nextContext: any): boolean, componentWillUnmount?(): void, componentDidCatch?(error: Error, errorInfo: React.ErrorInfo): void, getSnapshotBeforeUpdate?(prevProps: Readonly<P>, prevState: Readonly<S>): (SS | null), componentDidUpdate?(prevProps: Readonly<P>, prevState: Readonly<S>, snapshot?: SS): void, componentWillMount?(): void, UNSAFE_componentWillMount?(): void, componentWillReceiveProps?(nextProps: Readonly<P>, nextContext: any): void, UNSAFE_componentWillReceiveProps?(nextProps: Readonly<P>, nextContext: any): void, componentWillUpdate?(nextProps: Readonly<P>, nextState: Readonly<S>, nextContext: any): void, UNSAFE_componentWillUpdate?(nextProps: Readonly<P>, nextState: Readonly<S>, nextContext: any): void, setState<K extends keyof S>(state: (((prevState: Readonly<S>, props: Readonly<P>) => (Pick<S, K> | S | null)) | Pick<S, K> | S | null), callback?: () => void): void, forceUpdate(callBack?: () => void): void, props: Readonly<{children?: React.ReactNode}> & Readonly<P>, context: any, refs: {[p: string]: React.ReactInstance}}, new(props: P, context?: any): {state, handleChange, handleSave, render: {(): *, (): React.ReactNode}, componentDidMount?(): void, shouldComponentUpdate?(nextProps: Readonly<P>, nextState: Readonly<S>, nextContext: any): boolean, componentWillUnmount?(): void, componentDidCatch?(error: Error, errorInfo: React.ErrorInfo): void, getSnapshotBeforeUpdate?(prevProps: Readonly<P>, prevState: Readonly<S>): (SS | null), componentDidUpdate?(prevProps: Readonly<P>, prevState: Readonly<S>, snapshot?: SS): void, componentWillMount?(): void, UNSAFE_componentWillMount?(): void, componentWillReceiveProps?(nextProps: Readonly<P>, nextContext: any): void, UNSAFE_componentWillReceiveProps?(nextProps: Readonly<P>, nextContext: any): void, componentWillUpdate?(nextProps: Readonly<P>, nextState: Readonly<S>, nextContext: any): void, UNSAFE_componentWillUpdate?(nextProps: Readonly<P>, nextState: Readonly<S>, nextContext: any): void, setState<K extends keyof S>(state: (((prevState: Readonly<S>, props: Readonly<P>) => (Pick<S, K> | S | null)) | Pick<S, K> | S | null), callback?: () => void): void, forceUpdate(callBack?: () => void): void, props: Readonly<{children?: React.ReactNode}> & Readonly<P>, context: any, refs: {[p: string]: React.ReactInstance}}, prototype: {state, handleChange, handleSave, render: {(): *, (): React.ReactNode}, componentDidMount?(): void, shouldComponentUpdate?(nextProps: Readonly<P>, nextState: Readonly<S>, nextContext: any): boolean, componentWillUnmount?(): void, componentDidCatch?(error: Error, errorInfo: React.ErrorInfo): void, getSnapshotBeforeUpdate?(prevProps: Readonly<P>, prevState: Readonly<S>): (SS | null), componentDidUpdate?(prevProps: Readonly<P>, prevState: Readonly<S>, snapshot?: SS): void, componentWillMount?(): void, UNSAFE_componentWillMount?(): void, componentWillReceiveProps?(nextProps: Readonly<P>, nextContext: any): void, UNSAFE_componentWillReceiveProps?(nextProps: Readonly<P>, nextContext: any): void, componentWillUpdate?(nextProps: Readonly<P>, nextState: Readonly<S>, nextContext: any): void, UNSAFE_componentWillUpdate?(nextProps: Readonly<P>, nextState: Readonly<S>, nextContext: any): void, setState<K extends keyof S>(state: (((prevState: Readonly<S>, props: Readonly<P>) => (Pick<S, K> | S | null)) | Pick<S, K> | S | null), callback?: () => void): void, forceUpdate(callBack?: () => void): void, props: Readonly<{children?: React.ReactNode}> & Readonly<P>, context: any, refs: {[p: string]: React.ReactInstance}}}}
 */
export default function withFieldEditHandler(ComponentContainer) {
    return class extends React.Component {
        static defaultProps = {
            saving: false,
            isEditable: true
        };

        static propTypes = {
            isEditable: PropTypes.bool.isRequired
        };

        constructor(props) {
            super(props);
            this.state = {
                form: {value: props.value},
                open: false
            };
        }

        componentDidUpdate(prevProps, prevState) {
            if (prevProps.value !== this.props.value) {
                this.setState({form: {value: this.props.value}});
            }
        }

        handleKeyUp = e => {
            if (e.keyCode === 13) {
                this.handleSave();
            }
        };

        handleChange = updateTarget => {
            this.setState(state => update(state, updateTarget));
        };

        handleToggle = () => {
            this.setState({open: !this.state.open});
        };

        handleSave = () => {
            const {form} = this.state;
            this.setState({open: false});
            this.props.onUpdate(form);
        };

        handleChangeAndSave = updateTarget => {
            this.setState(
                state => update(state, updateTarget),
                () => {
                    this.setState({open: false});
                    this.props.onUpdate(this.state.form);
                }
            );
        };

        render() {
            const props = {...this.props};
            props.onChange = this.handleChange;
            props.onSave = this.handleSave;
            props.onToggle = this.handleToggle;
            props.onKeyUp = this.handleKeyUp;
            props.onChangeAndSave = this.handleChangeAndSave;

            return <ComponentContainer {...props} {...this.state} />;
        }
    };
}
